import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";

import { listingStates } from "../../util/flStates";
import { Box, Button, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

function SubscriptionFailure() {
  return <div>
  <Navbar />
    <Box
      sx={{
        textAlign: "center",
        padding: "2rem",
        border: "1px solid rgb(190, 70, 40)",
        borderRadius: "8px",
        backgroundColor: "rgb(192, 75, 45)",
      }}
    >
      <CheckCircleOutlineIcon sx={{ fontSize: 60, color: "white" }} />
      <Typography variant="h4" sx={{ color: "white", marginTop: "1rem" }}>
        Your subcription is unsuccessfull!
      </Typography>
      <div style={{marginTop: "10px", color: "black"}}>
        Please, try again.
      </div>
      
    </Box>
    <Footer/>
</div>;;
}

export default SubscriptionFailure;
